<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div>
    <!-- TABELA DE PROPOSTAS -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Propostas enviadas</h3>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead>
              <tr>
                <th style="width: 15px">Seq</th>
                <th>Data de envio</th>
                <th style="width: 30%">Leilão</th>
                <th style="width: 150px">Forma de pagamento</th>
                <th style="width: 25%">Proposta enviada</th>
                <th style="width: 20%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(proposta, index) in propostas" :key="proposta">
                <td data-label="Seq">
                  {{ index + 1 }}
                </td>
                <td data-label="Data">
                  {{ formatDateTime(proposta.created_at) }}
                </td>
                <td data-label="Leilão">
                  <div>{{ proposta.leilao_id }} - {{ proposta.leilao_titulo }}</div>
                  <div>
                    <b>Lote:&nbsp;</b>
                    {{ proposta.lote_numero }} - {{ proposta.lote_titulo }}
                  </div>
                  <div v-if="proposta.parcelas > 0">
                    <b>Praça:&nbsp;</b>
                    {{ proposta.praca }}
                  </div>
                  <div v-if="proposta.parcelas > 0">
                    <b>Data leilão:&nbsp;</b>
                    {{ formatDate(proposta.data_leilao) }}
                  </div>
                </td>
                <td data-label="Forma de pagamento">
                  <p v-if="proposta.parcelas > 0">PARCELADO</p>
                  <p v-else>À VISTA</p>
                </td>
                <td data-label="Valor proposta">
                  <div>
                    <b>Valor do bem:&nbsp;</b>
                    R$ {{ toCurrency(proposta.valor_bem) }}
                  </div>
                  <div>
                    <b>Valor proposta:&nbsp;</b>
                    R$ {{ toCurrency(proposta.valor_proposta) }}
                  </div>
                  <div v-if="proposta.parcelas > 0">
                    <div>
                      <b>Sendo:&nbsp;</b>
                    </div>
                    <div>
                      <b>% Entrada:&nbsp;</b>
                      {{ proposta.pct_entrada }}%
                    </div>
                    <div>
                      <b>Valor entrada:&nbsp;</b>
                      R$ {{ toCurrency(proposta.valor_entrada) }}
                    </div>
                    <div>
                      <b>Parcelamento:&nbsp;</b>
                      {{ formatarParcelas(proposta) }}
                    </div>
                    <div>
                      <b>Indice de correção:&nbsp;</b>
                      {{ proposta.indice }}
                    </div>
                  </div>
                </td>
                <td>
                  <!--
                  <a :href="'/proposta/' + proposta.hash" target="_blank" type="button" class="btn btn-primary btn-sm" style="width: 100%">
                    Visualizar
                  </a>
                  -->
                  <button
                    data-toggle="modal"
                    data-target="#visualizar-modal"
                    @click="(proposta_selecionada = proposta), (visualizar_proposta = true)"
                    type="button"
                    class="btn btn-primary btn-sm"
                    style="width: 100%"
                  >
                    Visualizar
                  </button>
                  <button
                    :class="proposta.deleted_at != null ? 'btn-secondary' : 'btn-danger'"
                    :disabled="proposta.deleted_at != null"
                    style="margin-top: 5px; width: 100%"
                    @click="revogar(proposta)"
                    type="button"
                    class="btn btn-sm"
                    data-toggle="collapse"
                    href="#collapse1"
                  >
                    Revogar
                  </button>
                  <label v-if="proposta.deleted_at != null" style="color: red">Proposta revogada em {{ formatDateTime(proposta.deleted_at) }}</label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + propostas.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- MODAL VISUALIZAR PROPOSTA -->
    <div
      class="modal fade"
      id="visualizar-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
      v-if="visualizar_proposta"
      @click.self="visualizar_proposta = false"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="visualizar_proposta = false">&times;</button>
              <h4>Proposta enviada</h4>
              <br />
              <div class="p-2">
                <proposta :proposta="proposta_selecionada" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import currencyController from "../controller/currencyController";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController, currencyController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      habilitacao_selecionado: "",
      filtro: "",
      paginas: [],
      propostas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome: "",
      estado: "",
      cidade: "",
      cidades: "",
      cpf_cnpj: "",
      endereco: "",
      email: "",
      fone: "",
      nome_contato: "",
      proposta_selecionada: "",
      visualizar_proposta: false,
    };
  },

  mounted() {
    console.log(this.propostas);
    this.buscarPropostas();
  },

  methods: {
    formatarParcelas(proposta) {
      let valor_proposta_convertido = Number(this.toNumber(proposta.valor_proposta));
      let valor_entrada = Number(this.toNumber(proposta.valor_entrada));

      let valor_qtd_parcelas = this.toCurrency((valor_proposta_convertido - valor_entrada) / proposta.parcelas);

      return proposta.parcelas + "x R$" + valor_qtd_parcelas;
    },

    revogar(proposta) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja cancelar essa proposta?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero cancelar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              form_proposta_id: proposta.id,
            };

            axios
              .post(`/user/proposta/delete`, data)
              .then((response) => {
                this.isLoading = false;

                if (response.data.success) {
                  this.showSuccessMessage("Proposta cancelada!");
                  this.buscarPropostas();
                } else {
                  this.showErrorMessageWithButtonAndReload("Ops...", "Essa proposta já foi revogada.");
                }
              })
              .catch((error) => {
                console.log(error);
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarPropostas();
      }
    },

    buscarPropostas() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/user/propostas/search`, data)
        .then((response) => {
          this.isLoading = false;

          this.propostas = response.data.propostas;

          console.log(this.propostas);

          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarPropostas();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1100px;
  margin-left: -250px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -20px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
